import React from 'react'

import { PublicationItemFragment } from '@sketch/gql-types'
import { Text } from '@sketch/components'

import PublicationThumbnail from '../PublicationThumbnail/'
import {
  HeartButton,
  ThumbnailWrapper,
  Wrapper,
} from './ListPublicationItem.styles'

export interface ListPublicationItemProps {
  className?: string
  publication: PublicationItemFragment
}

const ListPublicationItem = (props: ListPublicationItemProps) => {
  const { className, publication } = props

  return (
    <Wrapper className={className}>
      <ThumbnailWrapper>
        <PublicationThumbnail publication={publication} />
      </ThumbnailWrapper>
      <Text as="h1" textStyle="prominent.primary.E" overflow="ellipsis" $reset>
        {publication.share.name}
      </Text>
      <HeartButton publication={publication} flavour="list" trackHeartCount />
    </Wrapper>
  )
}

export default ListPublicationItem
